var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 238,
    height: 236,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "chat") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "58.751%",
    x2: "42.541%",
    y1: "96.486%",
    y2: "11.014%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "56.118%",
    x2: "48.956%",
    y1: "-50.572%",
    y2: "62.713%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "91.3%",
    x2: "50.372%",
    y1: "-361.834%",
    y2: "50.552%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "-.081%",
    x2: "99.97%",
    y1: "49.936%",
    y2: "49.936%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "183.139%",
    x2: "81.497%",
    y1: "275.688%",
    y2: "103.353%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6D6D6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M175.784 175.131c.28.335.728.502 1.12.502.952-.056 1.792-.781 1.904-1.73a1.466 1.466 0 0 0-.336-1.171c-.28-.335-.728-.502-1.12-.502-.952.056-1.792.78-1.904 1.73a1.25 1.25 0 0 0 .336 1.171zm-4.872.056c.28.335.728.502 1.12.502.952-.056 1.792-.781 1.904-1.73a1.466 1.466 0 0 0-.336-1.171c-.28-.335-.728-.502-1.12-.502-.952.055-1.792.78-1.904 1.73-.056.445.056.892.336 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9A9A",
    d: "M219.128 220.49h-84c-5.768 0-10.472-4.687-10.472-10.433v-44.355c0-5.746 4.704-10.433 10.472-10.433h83.944c5.768 0 10.472 4.687 10.472 10.433v44.355c.056 5.802-4.648 10.433-10.416 10.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M205.576 130.72c-1.288 9.932-1.68 17.91 1.904 21.313 3.584 3.348 12.712 10.6 7.84 17.519-4.872 6.918-10.64 8.592-10.64 8.592s3.024 9.708-6.72 10.098c-9.744.446-39.312-4.017-41.048-15.789-1.68-11.772 0-17.072-5.096-21.09-5.096-4.016-2.296-12.441 0-17.072 2.352-4.63-4.872-12.665 1.68-19.192 6.552-6.528 13.776-11.159 21.168-6.137 7.392 5.021 19.04 0 19.04 0 9.744 6.583 13.16 11.883 11.872 21.759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M139.888 181.045l-4.312 3.403s-3.584-9.875-6.944-19.527c-3.304-9.652-4.032-14.785-4.032-14.785l-9.408 2.51s2.296 11.661 4.592 27.339c2.296 15.677 7.784 22.15 11.984 22.763 4.2.558 20.664-14.004 20.664-14.004l-12.544-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M145.936 169.552c-2.744 4.017-5.712 7.81-8.848 11.493 0 0 5.712 7.141 11.928 9.485 6.272 2.343 13.664-29.96 13.664-29.96-7.56 0-11.48 1.45-16.744 8.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M197.96 175.187c-6.16-8.425-20.832-11.996-20.832-11.996-16.576-4.686-19.376-3.514-25.536 6.36-6.16 9.876-11.2 19.751-7.84 26.111 3.36 6.305 7.224 11.996 6.16 24.884h21.504v13.948c0 .446.28.836.672 1.004.392.167.896.056 1.176-.223l14.784-14.73h3.528a41.17 41.17 0 0 1 0-19.192c2.632-10.544 12.544-17.686 6.384-26.166z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M104.552 138.14H26.88c-5.768 0-10.472-4.686-10.472-10.432V83.353c0-5.746 4.704-10.433 10.472-10.433h77.616c5.768 0 10.472 4.687 10.472 10.433v44.355c.056 5.746-4.648 10.433-10.416 10.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M52.696 72.083c-15.904-3.738-29.848-2.343-34.272-13.669-4.424-11.326 0-26.892 0-26.892-4.592-.111-9.184-.613-13.72-1.45 0 0-4.648 17.574-4.2 31.634.448 14.06 5.6 16.18 14.224 21.536 8.624 5.356 21.28 9.038 21.28 9.038l16.688-20.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M75.208 78.667C85.68 83.465 92.176 92 96.712 111.026c4.536 19.025 6.664 27.338 6.664 27.338H86.128l-8.4-14.617-2.52-45.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    d: "M18.368 31.467s6.44-1.786 8.176-7.142c1.736-5.356 4.2-8.592 6.048-10.265 1.848-1.618-2.856-3.906-6.048 0l-3.192 3.905s4.928-15.399.616-16.85c-4.312-1.45-13.16 0-14.728 2.288-1.568 2.288-4.256 9.652-3.416 15.622.84 5.97 2.24 9.206 2.24 9.206l.056 2.399 10.248.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M169.68 153.428s1.008 5.69 0 9.038l-.672 2.343s-6.44-.557-6.328 5.468c.112 6.026 7 10.824 13.16 10.824s13.552-4.129 12.096-8.592c-1.512-4.52-3.304-3.85-3.304-6.026 0-2.176.952-10.656 2.352-16.235l-17.304 3.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M175.728 114.318c-8.96-.949-15.96 9.205-16.184 22.15-.224 12.943 4.48 18.801 11.704 20.363 7.224 1.562 17.08-4.91 19.544-9.875 2.408-4.854 12.992-29.681-15.064-32.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M190.848 139.257s5.208-3.683 7.56-1.228c2.352 2.455.392 10.266-3.752 10.824a7.24 7.24 0 0 1-6.44-2.176l2.632-7.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M172.144 109.017c-7 4.352-4.032 14.953 2.128 19.416 6.16 4.463 14.616 2.845 16.52 10.824 1.904 7.978 10.752 7.532 10.752 7.532s2.296-32.025-7.84-37.716c-10.136-5.69-15.4-3.85-21.56-.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M206.752 197.894l9.968 22.652h-13.888l-8.064-17.129z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M191.8 169.552c9.576 4.575 13.776 22.093 16.576 29.067 0 0-4.088 6.082-11.424 8.034l-3.192.837s-9.856-13.446-8.792-21.703 6.832-16.235 6.832-16.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M124.6 150.192s2.688-2.343 2.184-7.141c-.504-4.799-2.912-4.073-4.144-8.537-1.232-4.463-4.144-6.025-4.256-3.738-.112 2.288 3.416 7.142 1.568 8.202-1.792 1.116-9.464-10.043-12.824-8.704-3.416 1.34-5.432 10.378-3.024 12.777 2.408 2.399 11.088 9.652 11.088 9.652l9.408-2.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M60.928 72.362c-27.944-7.309-29.288 11.94-29.792 21.926-.448 9.987-2.352 44.076-2.352 44.076H59.92l14.448 14.394c.336.335.784.39 1.176.224.392-.168.672-.558.672-1.005v-13.613H82.6s2.128-35.93 0-45.694c-2.072-9.707-5.04-15.956-21.672-20.308z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    d: "M70.84 66.839s-3.08 6.137-3.36 8.76l4.144 2.733s6.664 12.776-7.336 12.497c-14-.279-15.736-15.454-15.624-18.634l4.032-.112s5.264-13.39 5.544-18.132l12.6 12.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    d: "M79.072 65.723c-5.824 5.077-9.24 4.296-12.152 1.562-2.912-2.734-10.192-8.201-8.512-18.132 1.68-9.931 2.744-16.124 7.616-18.244 4.872-2.12 21.728-1.116 21.448 10.265-.224 8.704-2.576 19.472-8.4 24.549z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    d: "M60.256 53.672s-4.816 2.79-5.824-3.18c-1.064-5.97 1.736-11.605 6.384-6.249l-.56 9.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M166.824 33.587V31.8c0-.892-.728-1.618-1.624-1.618-.896 0-1.624.726-1.624 1.618v1.786h-1.792c-.896.056-1.568.78-1.568 1.618 0 .892.672 1.618 1.568 1.618h1.792v1.785c0 .893.728 1.618 1.624 1.618.896 0 1.624-.725 1.624-1.618v-1.785h1.792c.616.055 1.176-.28 1.512-.781a1.516 1.516 0 0 0 0-1.674c-.336-.502-.896-.837-1.512-.781h-1.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#696969",
    d: "M234.024 134.012v-1.785c0-.893-.728-1.618-1.624-1.618-.896 0-1.624.725-1.624 1.618v1.785h-1.792c-.896.056-1.568.781-1.568 1.618 0 .893.672 1.618 1.568 1.618h1.792v1.786c0 .892.728 1.618 1.624 1.618.896 0 1.624-.726 1.624-1.618v-1.786h1.792c.616.056 1.176-.279 1.512-.78a1.516 1.516 0 0 0 0-1.675c-.336-.502-.896-.836-1.512-.78h-1.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F5F5F",
    d: "M21.224 155.66v-1.786c-.056-.892-.784-1.562-1.624-1.562-.84 0-1.624.67-1.624 1.562v1.786h-1.792c-.896.055-1.568.78-1.568 1.618 0 .892.672 1.618 1.568 1.618h1.736v1.785c.056.893.784 1.562 1.624 1.562.84 0 1.624-.67 1.624-1.562v-1.785h1.792c.896-.056 1.568-.782 1.568-1.618 0-.893-.672-1.618-1.568-1.618h-1.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M112.504 57.745a3.388 3.388 0 0 1-3.416-3.404 3.388 3.388 0 0 1 3.416-3.403 3.388 3.388 0 0 1 3.416 3.403 3.388 3.388 0 0 1-3.416 3.404zM72.408 194.212c0 1.395-.84 2.622-2.128 3.18-1.288.558-2.744.223-3.752-.725-1.008-1.005-1.288-2.455-.728-3.738.56-1.284 1.792-2.12 3.192-2.12.896 0 1.792.334 2.408 1.004.616.67 1.008 1.506 1.008 2.399zm155.12-136.69c0 1.394-.84 2.622-2.128 3.18-1.288.558-2.744.223-3.752-.726-1.008-1.004-1.288-2.454-.728-3.738.56-1.283 1.792-2.12 3.192-2.12.896 0 1.792.335 2.408 1.004a3.329 3.329 0 0 1 1.008 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M53.312 31.69c-3.92-7.476 3.304-8.927 5.824-9.317 2.8-.447 4.032-4.296 7.84-5.245 5.768-1.395 8.456 3.515 11.424 4.129 2.968.613 6.272-2.12 9.464 1.283s1.4 6.193 2.128 7.922c.728 1.786 4.648-.725 6.776 4.743 3.248 8.369-9.632 6.193-9.632 6.193s-7.56-.112-14.616-6.584c-.952-.948-2.408-1.171-3.64-.558-3.192 1.786-9.408 15.231-9.408 15.231l-1.848-3.347s-5.768-3.46-3.64-9.038c.504-1.06-.056-4.24-.672-5.412z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f490d038f1aadb2710d7b61cdcfc69b3.svg";
export { ForwardRef as ReactComponent };